'use client'

import React from 'react';
import Select from 'react-select';
import './filter.css';

const sortByOptions = [
  { value: 'rank', label: 'Rank' },
  { value: 'matchpoints', label: 'Matches Won' },
  { value: 'bonuspoints', label: 'Bonus Points' },
  { value: 'totalpoints', label: 'Total Points' },
  { value: 'beststreak', label: 'Best Streak' },
  { value: 'accuracy', label: 'Win%' },
  { value: 'loss', label: 'Matches Lost' },
];

const sortByOptionsOrder = [
  { value: 'asc', label: 'Low to High' },
  { value: 'desc', label: 'High to Low' },
];

const FilterRow = ({ sortCallback, orderCallback }) => {
  const handleSortChange = (e) => {
    sortCallback(e !== null ? e.value : 'totalpoints');
  };

  const handleOrderChange = (e) => {
    orderCallback(e !== null ? e.value : 'asc');
  };

  return (
    <div className="filter-row">
      <Select
        className="sort-by-filter"
        classNamePrefix="s"
        isDisabled={false}
        isLoading={false}
        isClearable={true}
        isRtl={false}
        isSearchable={true}
        name="sort-by-filter"
        options={sortByOptions}
        placeholder='Select Sort'
        onChange={handleSortChange}
        aria-label="Sort by"
      />
      <Select
        className="sort-by-filter-order"
        classNamePrefix="s"
        isDisabled={false}
        isLoading={false}
        isClearable={true}
        isRtl={false}
        placeholder='Select Order'
        isSearchable={true}
        name="sort-by-filter-order"
        options={sortByOptionsOrder}
        onChange={handleOrderChange}
        aria-label="Sort Order"
      />
    </div>
  );
};

export default FilterRow;
